import React, { useEffect, useState } from "react";
import Header from '../header/Header';
import Sidebarr from '../sidebar/Sidebar';
import VendorSidebar from '../sidebar/VendorSidebar';
import Tool from '../sidebar/Tool';
import Footer from '../footer/Footer';
import axios from "../helper/axios";
import { useSelector } from "react-redux";
import ReactPaginate from 'react-paginate';
import "./Custom.css"
import LoadingImg from "./loading.gif"
let page = 0;

const PaginatedItems = ({ itemsPerPage, dataLength, methodName }) => {
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;

  const pageCount = Math.ceil(dataLength / itemsPerPage);

  const handlePageClick = (event) => {
    methodName(event.selected);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  };

  return (
    <>
      <ReactPaginate
        nextLabel=">>"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel="<<"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item previous"
        previousLinkClassName="page-link"
        nextClassName="page-item next"
        nextLinkClassName="page-link"
        breakLabel="..."
        nextPageRel={true}
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination hCsSxg"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />
    </>
  );
}

export default function ProductList() {
  const [allProduct, setAllProduct] = useState({ products: [], totalCount: 0 });
  const auth = useSelector(state => state.auth);
  const [searchExternalId, setSearchExternalId] = useState("");
  const [searchName, setSearchName] = useState("");
  const [searchLocation, setSearchLocation] = useState("");
  const [locationOptions, setLocationOptions] = useState([]);
  const [per_page, setPer_Page] = useState(40);
  const [loading, setLoading] = useState(false);
  const [editProductId, setEditProductId] = useState("");
  const [editForm, setEditForm] = useState({
    name: "",
    description: "",
    season: "",
    location: "",
    gender: "",
    composition: "",
    countryOfOrigin: "",
    selectionForYou: false,
    newIn: false,
    published: false,
  });

  const apiData = async (page, per_page) => {
    setLoading(true);
    try {
      const res = await axios.post("/adminproductlists", {
        page,
        per_page,
        searchExternalId,
        searchName,
        locationName: searchLocation,
      });
      if (res.status === 200) {
        setAllProduct(res?.data || { products: [], totalCount: 0 });
      }
    } catch (error) {
      setAllProduct({ products: [], totalCount: 0 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    apiData(page, per_page);
  }, []);

  const loadLocations = async () => {
    try {
      const res = await axios.get("/adminproduct/locations");
      if (res.status === 200) {
        setLocationOptions(res?.data?.locations || []);
      }
    } catch (error) {
      setLocationOptions([]);
    }
  };

  useEffect(() => {
    loadLocations();
  }, []);

  const method = (page) => {
    apiData(page, per_page);
  };

  const getFirstSku = (product) => {
    const nested = product?.variants?.[0]?.sizes?.[0]?.skus?.[0];
    if (nested) return nested;
    return product?.skus?.[0] || {};
  };

  const startEdit = (product) => {
    const sku = getFirstSku(product);
    setEditProductId(product?._id || "");
    setEditForm({
      name: product?.name || "",
      description: product?.description || "",
      season: product?.attributes?.Season || "",
      location: product?.location || "",
      gender: product?.attributes?.Gender || "",
      composition: product?.attributes?.Composition || "",
      countryOfOrigin: product?.attributes?.["Country of origin"] || product?.attributes?.CountryOfOrigin || "",
      selectionForYou: Number(sku?.SelectionForYou || 0) === 1,
      newIn: Number(sku?.NewIn || 0) === 1,
      published: product?.published === true,
    });
  };

  const cancelEdit = () => {
    setEditProductId("");
    setEditForm({
      name: "",
      description: "",
      season: "",
      location: "",
      gender: "",
      composition: "",
      countryOfOrigin: "",
      selectionForYou: false,
      newIn: false,
      published: false,
    });
  };

  const saveEdit = async () => {
    if (!editProductId) return;
    setLoading(true);
    try {
      await axios.post("/adminproduct/update", {
        _id: editProductId,
        externalId: (allProduct?.products || []).find((p) => p?._id === editProductId)?.externalId,
        updatedBy: `${auth?.user?.fname || ""} ${auth?.user?.lname || ""}`.trim() || auth?.user?.email || "Unknown User",
        ...editForm,
        selectionForYou: editForm.selectionForYou ? 1 : 0,
        newIn: editForm.newIn ? 1 : 0,
        published: !!editForm.published,
      });
      await apiData(page, per_page);
      cancelEdit();
    } catch (error) {
      alert(error?.response?.data?.error || "Could not update product");
      setLoading(false);
    }
  };

  const filteredProducts = allProduct?.products || [];


  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        {auth?.user?.role === "Vendor" ? <VendorSidebar /> : <Sidebarr />}
        <div className="content-wrapper">
          <section className="content-header">
              <h1>
              All API Product List
              <small>it all starts here</small>
            </h1>
            <ol className="breadcrumb">
              <li>
                <a href="/#">
                  <i className="fa fa-dashboard" /> Home
                </a>
              </li>
              <li>
                <a href="/#">Product Manage</a>
              </li>
              <li className="active">All Product</li>
            </ol>
          </section>

          <section className="content">
            <div className="box box-section">
              <div className="box-body search-section">
                <div className='search-sku col-sm-3'>
                  <input
                    type="text"
                    placeholder='Search External ID'
                    value={searchExternalId}
                    onChange={(e) => setSearchExternalId(e.target.value)}
                  />
                </div>

                <div className='search-sku col-sm-3'>
                  <input
                    type="text"
                    placeholder='Search Product Name'
                    value={searchName}
                    onChange={(e) => setSearchName(e.target.value)}
                  />
                </div>

                <div className='search-status col-sm-3'>
                  <select
                    className="search-select"
                    value={searchLocation}
                    onChange={(e) => setSearchLocation(e.target.value)}
                  >
                    <option value="">All Locations</option>
                    {locationOptions.map((location) => (
                      <option key={location} value={location}>
                        {location}
                      </option>
                    ))}
                  </select>
                </div>

                <div className='search-status col-sm-3'>
                  {loading ? <div className="btn gif-button">
                    <img src={LoadingImg} height="40" width="40" alt='loadImage' /></div> : <button onClick={() => { page = 0; apiData(0, per_page); }} style={{ marginLeft: "-1px", marginTop: "4px" }}>Search</button>}
                </div>

              </div>
            </div>

            {/* Default box */}
            <div className="box">
              <div className="box-header with-border">
                {filteredProducts?.length === 0 ? <span className="label label-danger">Product Not Found</span> : ""}
                <div className="box-tools pull-right">
                </div>
              </div>
              <div className="box-body">
                <div className='order-page'>
                  <table className="table table-bordered table-striped dataTable product-table" >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Action</th>
                        <th>External Id</th>
                        <th>Name</th>
                        <th className="col-description">Description</th>
                        <th>Season</th>
                        <th>Location</th>
                        <th>Selection For You</th>
                        <th>New In</th>
                        <th>Published</th>
                        <th>Brand</th>
                        <th>Size</th>
                        <th>Colour</th>
                        <th>Gender</th>
                        <th>Composition</th>
                        <th>Country Of Origin</th>
                        <th>Updated By</th>
                        <th>Updated Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredProducts?.length > 0 ? filteredProducts?.map((dt, index) => {
                        const sku = getFirstSku(dt);
                        const isEditing = editProductId === dt?._id;
                        return (
                          <tr key={dt?._id || index}>
                            <td>{index + 1}</td>
                            <td>
                              {isEditing ? (
                                <>
                                  <button className="btn btn-success btn-xs" onClick={saveEdit} style={{ marginRight: "6px" }}>
                                    Save
                                  </button>
                                  <button className="btn btn-default btn-xs" onClick={cancelEdit}>
                                    Cancel
                                  </button>
                                </>
                              ) : (
                                <button className="btn btn-default btn-xs" onClick={() => startEdit(dt)}>
                                  Edit
                                </button>
                              )}
                            </td>
                            <td>{dt?.externalId || "-"}</td>
                            <td>{isEditing ? <input value={editForm.name} onChange={(e) => setEditForm({ ...editForm, name: e.target.value })} /> : (dt?.name || "-")}</td>
                            <td className="col-description">{isEditing ? <textarea value={editForm.description} onChange={(e) => setEditForm({ ...editForm, description: e.target.value })} /> : (dt?.description || "-")}</td>
                            <td>{isEditing ? <input value={editForm.season} onChange={(e) => setEditForm({ ...editForm, season: e.target.value })} /> : (dt?.attributes?.Season || "-")}</td>
                            <td>{isEditing ? <input value={editForm.location} onChange={(e) => setEditForm({ ...editForm, location: e.target.value })} /> : (dt?.location || "-")}</td>
                            <td>
                              {isEditing ? (
                                <input
                                  type="checkbox"
                                  checked={editForm.selectionForYou}
                                  onChange={(e) => setEditForm({ ...editForm, selectionForYou: e.target.checked })}
                                />
                              ) : (
                                <input type="checkbox" checked={Number(sku?.SelectionForYou || 0) === 1} readOnly />
                              )}
                            </td>
                            <td>
                              {isEditing ? (
                                <input
                                  type="checkbox"
                                  checked={editForm.newIn}
                                  onChange={(e) => setEditForm({ ...editForm, newIn: e.target.checked })}
                                />
                              ) : (
                                <input type="checkbox" checked={Number(sku?.NewIn || 0) === 1} readOnly />
                              )}
                            </td>
                            <td>
                              {isEditing ? (
                                <input
                                  type="checkbox"
                                  checked={editForm.published}
                                  onChange={(e) => setEditForm({ ...editForm, published: e.target.checked })}
                                />
                              ) : (
                                <input type="checkbox" checked={dt?.published === true} readOnly />
                              )}
                            </td>
                            <td>{dt?.brand || "-"}</td>
                            <td>{sku?.skuSpecs?.size || dt?.variants?.[0]?.sizes?.[0]?.size || "-"}</td>
                            <td>{sku?.skuSpecs?.colour || dt?.variants?.[0]?.colour || "-"}</td>
                            <td>{isEditing ? <input value={editForm.gender} onChange={(e) => setEditForm({ ...editForm, gender: e.target.value })} /> : (dt?.attributes?.Gender || "-")}</td>
                            <td>{isEditing ? <input value={editForm.composition} onChange={(e) => setEditForm({ ...editForm, composition: e.target.value })} /> : (dt?.attributes?.Composition || "-")}</td>
                            <td>{isEditing ? <input value={editForm.countryOfOrigin} onChange={(e) => setEditForm({ ...editForm, countryOfOrigin: e.target.value })} /> : (dt?.attributes?.["Country of origin"] || dt?.attributes?.CountryOfOrigin || "-")}</td>
                            <td>{dt?.updatedBy || "-"}</td>
                            <td>{dt?.updatedByLabel ? dt.updatedByLabel.split(" - ")[1] : "-"}</td>
                          </tr>
                        );
                      }) : <tr><td colSpan="18">No records found</td></tr>}

                    </tbody>
                  </table>
                </div>
                <div className='pagination_wrp'>
                </div>
              </div>
            </div>
            <PaginatedItems itemsPerPage={per_page} dataLength={allProduct?.totalCount} methodName={method} />
          </section>
        </div>
        <Footer />
        <Tool />
        <div className="control-sidebar-bg" />
      </div>
    </div>
  )
}

